import envConfig from '@acre/config'

import createAxiosInstance from '../utils/createAxiosInstance'

const axiosInstance = createAxiosInstance(
  {
    baseURL: envConfig.CLIENT_PORTAL_API_URL,
    withCredentials: true,
  },
  {
    useLutherInterceptor: true,
    useCpApiKey: true,
  },
)

export default axiosInstance
